import { useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { Image, Upload, message } from 'antd'
import styles from '../../../../../testrun.module.css'

const ALLOWED_HINT = 'Images, PDF, or Word documents · max 10 files'
const INVALID_TYPE_MSG = 'Only images, PDF, and DOC/DOCX are allowed.'

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
    })

function isAllowedFile(file) {
    return (
        file.type.startsWith('image/') ||
        file.type === 'application/pdf' ||
        file.type ===
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        file.type === 'application/msword'
    )
}

export default function Attachments({
    fileList = [],
    setFileList = () => {},
    errorMessage = '',
    setErrorMessage = () => {},
}) {
    const [previewOpen, setPreviewOpen] = useState(false)
    const [previewImage, setPreviewImage] = useState('')

    const maxCount = 10

    const beforeUpload = (file) => {
        if (!isAllowedFile(file)) {
            setErrorMessage(INVALID_TYPE_MSG)
            return Upload.LIST_IGNORE
        }

        setErrorMessage('')
        return false
    }

    const handlePreview = async (file) => {
        if (
            !file.url &&
            !file.preview &&
            file.originFileObj &&
            file.type?.startsWith('image/')
        ) {
            file.preview = await getBase64(file.originFileObj)
        }
        if (file.type?.startsWith('image/')) {
            setPreviewImage(file.url || file.preview)
            setPreviewOpen(true)
        } else {
            message.info('Preview is available only for images.')
        }
    }

    const uploadButton = (
        <div className={styles.resultUploadTrigger}>
            <PlusOutlined />
            <span>Upload</span>
        </div>
    )

    return (
        <div className={styles.resultUploadWrap}>
            <Upload
                listType="picture-card"
                className={`${styles.resultUpload} ${
                    errorMessage ? styles.resultUploadHasError : ''
                }`}
                fileList={fileList}
                name="files"
                maxCount={maxCount}
                multiple
                accept="image/*,.pdf,.doc,.docx"
                beforeUpload={beforeUpload}
                onPreview={handlePreview}
                onChange={({ fileList: newList }) => {
                    setFileList(newList)
                }}
            >
                {fileList.length >= maxCount ? null : uploadButton}
            </Upload>

            {errorMessage ? (
                <p className={styles.resultAttachmentError} role="alert">
                    {errorMessage}
                </p>
            ) : (
                <p className={styles.resultAttachmentsHint}>{ALLOWED_HINT}</p>
            )}

            {previewImage && (
                <Image
                    wrapperStyle={{ display: 'none' }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (v) => setPreviewOpen(v),
                        afterOpenChange: (v) => !v && setPreviewImage(''),
                    }}
                    src={previewImage}
                />
            )}
        </div>
    )
}
